import React from "react";
import shop from "shop/shop";
import { Button, Table } from "semantic-ui-react";

export function ProductDownloads( { product } ) {
  const [resources, setResources] = React.useState( false )
  const [loading, setLoading] = React.useState( false )
  React.useEffect( () => {
    async function load() {
      setLoading( true )
      let res = await shop.fetch( `/shop/rest/data/v1/article/resources/${product.map_id}` )
      setResources( res )
      setLoading( false )
    }
    
    load()
  }, [product] )
  
  
  return <div>
    {loading && <Button basic loading/>}
    {!loading && <div>
      {resources && resources.map( filePackage => {
        return <div key={filePackage.content}>
          {console.log("filepackage",filePackage)}
          <h4>{translate( "Produktdatenblatt" )}</h4>
          <Table basic={"very"}>
            <Table.Body>
              <Table.Row>
                <Table.Cell>
                  <Button basic size={"tiny"} as={"a"} target={"_blank"} download={filePackage.content}
                          href={`${shop.config.API}data/v1/article/resources/${product.map_id}/${filePackage.map_id}`}>Datei herunterladen</Button>
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </div>
      } )}
    </div>}
  </div>
}


// WEBPACK FOOTER //
// ./src/theme/braunsheitmannShop/components/ProductDownloads.js